module.exports = __webpack_public_path__ + "static/media/PDF_43.0bb44725.pdf";